"use client";

import * as React from "react";
import { useForm } from "react-hook-form";
import { Mail, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Link } from "@/components/common/Link";
import { Textarea } from "@/components/ui/textarea";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
export default function ContactInformation() {
  const form = useForm({
    defaultValues: {
      name: "",
      email: "",
      message: ""
    }
  });
  const onSubmit = (data: any) => {
    const subject = encodeURIComponent("Consulta desde el formulario de contacto");
    const body = encodeURIComponent(`Nombre: ${data.name}\nEmail: ${data.email}\n\nMensaje:\n${data.message}`);
    window.location.href = `mailto:contacto@zafiroinvestment.com?subject=${subject}&body=${body}`;
  };
  return <section className="bg-background py-16 lg:py-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="grid grid-cols-12 gap-8 lg:gap-12">
          {}
          <div className="col-span-12 lg:col-span-7">
            <div className="mb-8 animate-fade-in-up">
              <h2 className="mb-4 font-display text-4xl font-semibold text-foreground lg:text-5xl">
                Contáctanos
              </h2>
              <p className="text-lg leading-relaxed text-muted-foreground">
                Estamos aquí para ayudarte con cualquier consulta sobre nuestros
                cursos de inversión. Completa el formulario y te responderemos
                pronto.
              </p>
            </div>

            <Form {...form}>
              <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6 animate-fade-in-up" style={{
              animationDelay: "150ms"
            }}>
                <FormField control={form.control} name="name" render={({
                field
              }) => <FormItem>
                      <FormLabel className="text-base font-medium text-foreground">
                        Nombre completo
                      </FormLabel>
                      <FormControl>
                        <Input placeholder="Tu nombre" {...field} className="h-11 rounded-md border border-border bg-surface px-4 py-3 text-base shadow-soft transition-all duration-[var(--duration-medium)] focus:border-primary focus:shadow-medium" />
                      </FormControl>
                      <FormMessage />
                    </FormItem>} />

                <FormField control={form.control} name="email" render={({
                field
              }) => <FormItem>
                      <FormLabel className="text-base font-medium text-foreground">
                        Correo electrónico
                      </FormLabel>
                      <FormControl>
                        <Input type="email" placeholder="tu@email.com" {...field} className="h-11 rounded-md border border-border bg-surface px-4 py-3 text-base shadow-soft transition-all duration-[var(--duration-medium)] focus:border-primary focus:shadow-medium" />
                      </FormControl>
                      <FormMessage />
                    </FormItem>} />

                <FormField control={form.control} name="message" render={({
                field
              }) => <FormItem>
                      <FormLabel className="text-base font-medium text-foreground">
                        Mensaje
                      </FormLabel>
                      <FormControl>
                        <Textarea placeholder="Cuéntanos cómo podemos ayudarte..." {...field} className="min-h-32 rounded-md border border-border bg-surface px-4 py-3 text-base shadow-soft transition-all duration-[var(--duration-medium)] focus:border-primary focus:shadow-medium" />
                      </FormControl>
                      <FormMessage />
                    </FormItem>} />

                <Button type="submit" className="btn-primary h-12 w-full rounded-md px-8 text-base font-semibold shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:-translate-y-0.5 hover:shadow-strong lg:w-auto">
                  Enviar mensaje
                </Button>
              </form>
            </Form>
          </div>

          {}
          <div className="col-span-12 lg:col-span-5">
            <div className="rounded-lg border border-border bg-surface p-8 shadow-soft transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1 hover:shadow-medium animate-fade-in-up lg:sticky lg:top-8" style={{
            animationDelay: "300ms"
          }}>
              <h3 className="mb-6 font-display text-2xl font-semibold text-foreground">
                Información de contacto
              </h3>

              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="flex size-12 shrink-0 items-center justify-center rounded-md bg-primary/10">
                    <Mail className="size-6 text-primary" />
                  </div>
                  <div>
                    <p className="mb-1 text-sm font-medium uppercase tracking-wide text-muted-foreground">
                      Email
                    </p>
                    <Link to="mailto:contacto@zafiroinvestment.com" className="text-lg font-medium text-foreground transition-colors duration-[var(--duration-fast)] hover:text-primary">
                      contacto@zafiroinvestment.com
                    </Link>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="flex size-12 shrink-0 items-center justify-center rounded-md bg-secondary/10">
                    <Phone className="size-6 text-secondary" />
                  </div>
                  <div>
                    <p className="mb-1 text-sm font-medium uppercase tracking-wide text-muted-foreground">
                      Teléfono
                    </p>
                    <Link to="tel:+15551234567" className="text-lg font-medium text-foreground transition-colors duration-[var(--duration-fast)] hover:text-secondary">
                      321-247-1391
                    </Link>
                  </div>
                </div>
              </div>

              <div className="mt-8 border-t border-border pt-6">
                <p className="text-sm leading-relaxed text-muted-foreground">
                  Nuestro equipo está disponible de lunes a viernes, de 9am a
                  6pm, para responder todas tus preguntas sobre inversión en la
                  bolsa de valores.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}